import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { PendingUsersService } from '../../../core/routing/services/pendingUsers/pending-users.service';
import { CommonService } from '../../../common/services/common.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs';

@Component({
  selector: 'iposcen-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  tabIndex: number;
  currentdetailPage: string;
  loginUserRole = sessionStorage.getItem('userRole');
  pendingUsers;
  paginationCount: number;
  isUkrainian = localStorage.getItem('preferredLanguage') === 'uk';
  hideUsersNav: boolean;
  private ngUnsubscribe = new Subject<boolean>();
  constructor(private router: Router, private location: Location,
    private pendingUsersService: PendingUsersService, private cmnService: CommonService) { }

  ngOnInit(): void {
    this.tabIndex = 0;
    this.currentdetailPage = this.router.url;
    const pageName = this.currentdetailPage.lastIndexOf('/');
    if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.USERS_RETAILHQS) {
      this.tabIndex = 0;
    }
    else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.USERS_STORES) {
      this.tabIndex = 1;
    }
    else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.USERS_ACTIVEUSERS) {
      this.tabIndex = 2;
    }
    // else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.USERS_OEMS) {
    //   this.tabIndex = 3;
    // }
    else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.USERS_PENDINGUSERS) {
      this.tabIndex = 4;
    }
    else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.USERS_DOMAINWHITELIST) {
      this.tabIndex = 5;
    }
    if (this.loginUserRole == GlobalConstants.INTEL_ADMIN || this.loginUserRole == GlobalConstants.RETAIL_HQ_USER || this.loginUserRole == GlobalConstants.REGIONALHQ) {
      this.getPendingUsersCount();
    }
    this.pendingUsersService.pendingUsersNum.subscribe(counter => {
      this.paginationCount = +counter;
    });
    this.cmnService.retailPageObserver
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(resp => {
        this.hideUsersNav = resp;
      });
  }
  setIndex(ind: number) {
    if (ind === 0) {
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.USERS + GlobalConstants.SLASH + GlobalConstants.USERS_RETAILHQS)
    } else if (ind === 1) {
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.USERS + GlobalConstants.SLASH + GlobalConstants.USERS_STORES);
    }
    else if (ind === 2) {
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.USERS + GlobalConstants.SLASH + GlobalConstants.USERS_ACTIVEUSERS);
    }
    else if (ind === 5) {
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.USERS + GlobalConstants.SLASH + GlobalConstants.USERS_DOMAINWHITELIST);
    }
    else if (ind === 4) {
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.USERS + GlobalConstants.SLASH + GlobalConstants.USERS_PENDINGUSERS);
    }
  }

  getPendingUsersCount() {
    this.pendingUsersService.getAllPendingUsers(1).subscribe(pendingUsers => {
      this.paginationCount = (pendingUsers.paginationContext.totalItems);
    });
  }

}
